module.exports = __webpack_public_path__ + "static/media/Sentient_AerialCombo.b5972446.gif";